import { t } from '../../i18n'
import Primary from "../layouts/Primary";

import './Sponsors.css'
import {useContext, useEffect, useRef, useState} from "react";
import {useInterval} from "../../hooks";
import {Sponsor} from "../../javaTypes";
import {useSlides} from "../util";
import DisplayParams from "../DisplayParams";

export function useSponsors(sponsorsUrl?: string) {
    const [chunkedSponsors, setChunkedSponsors] = useState<Sponsor[][]>([]);
    async function fetchSponsors() {
        if(!sponsorsUrl) {
            return;
        }
        const rawSponsors = await fetch(sponsorsUrl, {
            credentials: "same-origin"
        });
        const sponsors = await rawSponsors.json() as Sponsor[];
        const chunked = sponsors.reduce<Sponsor[][]>((arr, sponsor) => {
            if(sponsor.level === 'GLOBAL') {
                // if the global sponsor is the presenting sponsor they get their own page
                if(arr.length === 0 || arr[arr.length - 1].length >= 2 || arr[arr.length - 1][0].level !== sponsor.level
                    || arr[arr.length - 1][0].position === 1 ) {
                    arr.push([sponsor]);
                } else {
                    arr[arr.length - 1].push(sponsor);
                }
            } else {
                if(arr.length === 0 || arr[arr.length - 1].length >= 4 || arr[arr.length - 1][0].level !== sponsor.level) {
                    arr.push([sponsor]);
                } else {
                    arr[arr.length - 1].push(sponsor);
                }
            }
            return arr;
        }, []);
        setChunkedSponsors(chunked);
    }
    useInterval(fetchSponsors, 60000)
    useEffect(() => {
        fetchSponsors();
    }, [])

    return chunkedSponsors
}

function SingleSponsor({sponsor} : {
    sponsor: Sponsor
}) {
    return <>
        {sponsor.title ? <div className={"singleSponsorTitle"}>{sponsor.title}</div> : sponsor.title}
        {sponsor.logo ? <div className={`sponsorImageContainer ${sponsor.title ? 'withTitle' : ''} ${sponsor.position ? `position${sponsor.position}` : ''}`}>
        <img className="sponsorImage" src={sponsor.logo} />
    </div> : null }
    </>;
}

function MultiSponsor({sponsors, isGlobal} : {
    sponsors: Sponsor[],
    isGlobal: boolean
}) {
    return <div className={`sponsorContainer ${isGlobal ? 'twoSponsors' : ''}`}>{sponsors.map((sponsor, idx) => {
        return <div key={sponsor.sponsorId} className={`sponsorCell`}>
            <div className={"sponsorTitle"}>{sponsor.title}</div>
            {sponsor.logo ? <div className={"sponsorImageContainerSm"}>
                <img className="sponsorImage" src={sponsor.logo} />
            </div> : <div className={"sponsorName"}>{sponsor.name}</div> }
        </div>
    })}</div>;
}

export function StatelessSponsors({ sponsors}: {
    sponsors?: Sponsor[]
}) {
    let chunkLevel = sponsors ? sponsors[0].level : null;

    return <Primary>
        {/* Make sure the presenting sponsor gets a standalone page */}
        {sponsors ? (chunkLevel === 'GLOBAL' && sponsors[0].position === 1 ? <SingleSponsor sponsor={sponsors[0]} /> : <MultiSponsor sponsors={sponsors} isGlobal={chunkLevel === 'GLOBAL'} />) : null}

    </Primary>;
}

export default function Sponsors() {
    const params = useContext(DisplayParams)
    const chunkedSponsors = useSponsors(params.sponsorsUrl)
    const currentChunkIdx = useSlides(chunkedSponsors.length)
    const chunk = chunkedSponsors[currentChunkIdx];

    if(!params.sponsorsUrl) {
        return <>{"Cannot display sponsors-missing url"}</>;
    }

    return <StatelessSponsors sponsors={chunk} />
}